<app-layout>
    <div class="card p-0" *ngFor="let rota of rotaGecmis">
        <div class="card-header"> 
            <h3 class="card-title"> {{convertDate(rota[0].olusturmaTarihi)}} tarihli  <span class="text-primary">%{{ rota[0].oran }} {{ rota[0].tur }}</span></h3>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table card-table table-vcenter text-nowrap datatable">
                    <thead>
                        <tr>
                            <th>Açıklama</th>                                     
                            <th>Oran</th>                
                            <th>Tur</th>             
                            <th>Eski Fiyat</th> 
                            <th>Yeni Fiyat</th>         
                            <th>Değişimi Yapan</th>         
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let detail of rota">
                            <td>{{ detail.aciklama }}</td>
                            <td>%{{ detail.oran }}</td>
                            <td>{{ detail.tur }}</td>
                            <td>{{ detail.eskiFiyat }}₺</td>
                            <td>{{ detail.yeniFiyat }}₺</td>
                            <td>{{ detail.kullanici.adSoyad || "-" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div *ngIf="!rotaGecmis.length" class="card p-0">
        <div class="card-body text-center">
            Rota geçmişi bulunmamaktadır.
        </div>
    </div>
</app-layout>